<template>
  <div class="container">
    <b-modal
      :model-value="modAsociaDesasociaRol"
      :no-close-on-backdrop="true"
      hide-footer
      hide-header-close
      centered
      size="xl"
      dialog-class="modal-roles-wide"
      :title="infoMenu[0]?.nombre || labels.title"
      header-class="reset-modal-header"
      title-class="reset-modal-title"
      body-class="reset-modal-body"
      class="reset-password-dialog"
    >
        <div class="uniform-modal-body uniform-modal-body--wide">
            <div class="password-policy-box mb-4">
                <div class="password-policy-title">{{ labels.infoTitle }}</div>
                <div class="password-policy-subtitle">{{ labels.infoText }}</div>
            </div>
            <div class="roles-modal-body">
                <b-row v-for="rol in listRoles" :key="rol.id" class="role-row align-items-center"> 
                    <b-col cols="8" class="text-left role-name">{{ rol?.nombre }}</b-col>
                    <b-col cols="4" class="text-right">
                        <b-form-checkbox
                          v-model="rolSelected"
                          :value="rol?.id"
                          switch
                          class="mb-0"
                        >
                          {{ isRoleSelected(rol?.id) ? labels.active : labels.inactive }}
                        </b-form-checkbox>
                    </b-col>
                </b-row>
            </div>
            <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                <b-button class="mr-2 reset-btn-secondary" @click="cierraModal">{{ labels.close }}</b-button>
                <b-button class="reset-btn-primary" @click="guardarMenu">{{ labels.save }}</b-button>
            </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
import Menu from '../../../services/Menu'; 
import Roles from '../../../services/Roles'; 

export default {
    name: "AsociaDesasociaRol",
    props: ['modAsociaDesasociaRol', 'infoMenu'],
    data: () => ({
        rolAsociados: [],
        listRoles: [],
        rolSelected: []
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Menú:",
                    save: "Guardar",
                    close: "Cerrar",
                    active: "Activo",
                    inactive: "Inactivo",
                    infoTitle: "Roles del menú",
                    infoText: "Activa o desactiva los roles asociados al menú."
                }
            } else {
                return {
                    title: "Menu:",
                    save: "Save",
                    close: "Close",
                    active: "Active",
                    inactive: "Inactive",
                    infoTitle: "Menu roles",
                    infoText: "Toggle the roles associated with the menu."
                }
            }
        }
    },
    mounted() {
        Roles.getAllRoles() 
            .then((res) => { 
                this.listRoles = res.data.roles 
                if (this.infoMenu && this.infoMenu.length > 0) {
                    this.processInfoMenu(this.infoMenu)
                }
            })
            .catch((err) => { 
                console.log(err) 
            })
    },
    methods: {
        isRoleSelected(roleId) {
            return this.rolSelected.includes(roleId)
        },
        cierraModal() {
            this.$emit('closeModal', false) 
            this.rolSelected = []
        },
        processInfoMenu(dataMenu) {
            if (!dataMenu || !dataMenu.length) return
            
            let rol = []
            dataMenu.forEach(elem => { 
                rol = elem.roles 
            })
            
            if (!rol) return
            
            const numbers = []
            const arrayRol = String(rol).split(',')
            arrayRol.forEach(element => {
                const num = Number(element.trim())
                if (!isNaN(num)) {
                    numbers.push(num)
                }
            })
            
            this.rolAsociados = [...numbers]
            
            this.rolSelected = numbers.filter(valor => 
                this.listRoles.some(option => option.id === valor)
            )
        },
        guardarMenu() {
            if (!this.infoMenu || !this.infoMenu[0] || !this.infoMenu[0].id) {
                this.$toast.error("Error: No se encontró el menú")
                return
            }
            
            let datos = {
                'idMenu': this.infoMenu[0].id, 
                'rolesAsociados': this.rolSelected
            }

            Menu.updateRolesByMenu(datos) 
                .then((res) => { 
                    if (res.status == 200) { 
                        this.$toast.success(res.data.message) 
                        this.$emit('updated')
                        this.cierraModal()
                    }
                })
                .catch((err) => {
                    console.log(err) 
                    this.$toast.error("Error al actualizar los roles del menú")
                })
        }
    },
    watch: {
        infoMenu: {
            immediate: true,
            handler(dataMenu) {
                if (this.listRoles && this.listRoles.length > 0) {
                    this.processInfoMenu(dataMenu)
                }
            }
        }
    }
}
</script>